import React, { useEffect, useState } from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import * as Mui from '@material-ui/core';
import * as MuiIcons from '@material-ui/icons';
import Paper from '@material-ui/core/Paper';
import Lottie from 'react-lottie';

import emptyStateAnimation from '~/assets/animations/cart.json';
import animationUploading from '~/assets/animations/upload-to-cloud.json';

// import { Container } from './styles';

const ModalRetentativasTransmissao = ({ showModal, onClose }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  return (
    <Mui.Dialog
      open={showModal}
      onKeyDown={key => {
        if (key.code === 'Escape') {
          onClose();
        }
      }}
      PaperComponent={Paper}
      maxWidth={'lg'}
    >
      <Mui.DialogTitle>
        <Mui.AppBar color="primary" position="static">
          <Mui.Toolbar>
            <Mui.Box>
              <Mui.Typography variant="h5" style={{ textTransform: 'upperCase' }}>
                Erro ao enviar documento 22/47747
              </Mui.Typography>
            </Mui.Box>
            <Mui.Box flexGrow={1} />
          </Mui.Toolbar>
        </Mui.AppBar>
      </Mui.DialogTitle>
      <Mui.DialogContent dividers style={{ width: 640 }}>
        <Mui.Box p={2}>
          <Lottie
            style={{
              backgroundColor: alpha(theme.palette.common.black, 0.08),
              borderRadius: '100%',
              marginBottom: 16,
              pointerEvents: 'none'
            }}
            options={{
              loop: true,
              autoplay: true,
              animationData: animationUploading,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
              }
            }}
            height={256}
            width={256}
            isStopped={false}
            isPaused={false}
          />
          <Mui.Typography></Mui.Typography>
        </Mui.Box>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Box p={1} display="flex" justifyContent="space-between" alignItems="center">
          <Mui.Box display="flex">
            <Mui.Button size="large" className="button-success">
              <MuiIcons.Sync /> <span style={{ paddingLeft: 8 }}>Tentar novamente </span>
            </Mui.Button>
            <Mui.Button size="large" variant="contained" color="primary" style={{ marginLeft: 16 }}>
              <MuiIcons.CloudDownload />
              <span style={{ paddingLeft: 8 }}> Gerar offline </span>
            </Mui.Button>
          </Mui.Box>
          <Mui.Button size="large" onClick={onClose} style={{ marginLeft: 16 }}>
            <MuiIcons.Close />
            <span style={{ paddingLeft: 8 }}>Cancelar</span>
          </Mui.Button>
        </Mui.Box>
      </Mui.DialogActions>
    </Mui.Dialog>
  );
};

export default ModalRetentativasTransmissao;
